export const lazyLoadIframes = () => {

	//Load in videos and start them playing when they reach the viewport

	var lazyIframes = [].slice.call(document.querySelectorAll("iframe.js__lazy-iframe"));

	if ("IntersectionObserver" in window) {
		var lazyIframeObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(iframe) {
				if (iframe.isIntersecting) {
					
					let realSrc = iframe.target.dataset.src;

					iframe.target.src = realSrc;
					iframe.target.dataset.src = '';
					
					lazyIframeObserver.unobserve(iframe.target);
				}
			});
		});

		lazyIframes.forEach(function(lazyIframe) {
			lazyIframeObserver.observe(lazyIframe);
		});
	}

}